module.exports = __webpack_public_path__ + "static/img/2.25efa09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-vida/2.png
// module id = Iytg
// module chunks = 0